import {
	Component,
	ElementRef,
	Input,
	ViewChild
}                               from '@angular/core';
import { IFileDropInputConfig } from '@shared/components/file-drop/file-drop.model';
import { FileDropService }      from '@shared/components/file-drop/file-drop.service';

@Component( {
	selector: 'app-file-drop-input[fileDropService][groupId]',
	templateUrl: './file-drop-input.component.html',
	styleUrls: [ './file-drop-input.component.scss' ]
} )
export class FileDropInputComponent {

	private _fileDropService: FileDropService;
	private _groupId: string;
	private _fileDropInputConfig: IFileDropInputConfig;

	acceptedFileTypes: string[];
	allowMultiFileDrop: boolean;

	get fileDropInputConfig(): IFileDropInputConfig {
		return this._fileDropInputConfig;
	}

	@Input() set groupId( groupId: string ) {
		this._groupId = groupId;
		this.init();
	}

	@Input() set fileDropService( fileDropService: FileDropService ) {
		if ( !fileDropService || this._fileDropService ) { return; }
		this._fileDropService = fileDropService;
		this.init();
	}

	get fileDropService(): FileDropService {
		return this._fileDropService;
	}

	@Input() isRendered = true;
	@Input() isDisabled = false;
	@Input() isHidden = false;

	@Input() description: string;
	@Input() infoText: string;
	@Input() styleClass: string;

	@ViewChild( 'fileDropInput' ) fileDropInput: ElementRef;

	constructor() { }

	init(): void {
		if ( !this._fileDropService || !this._groupId ) { return; }

		this._fileDropInputConfig = this.fileDropService?.getFileDropInputConfigByGroupId( this._groupId );
		this.acceptedFileTypes = this.fileDropInputConfig?.acceptedFileTypes;
		this.allowMultiFileDrop = this.fileDropInputConfig?.allowMultiFileDrop;
		this.allowMultiFileDrop = this.fileDropInputConfig?.allowMultiFileDrop;
	}

	onFilesChange( files: File[] | FileList ) {
		this.fileDropService.buildImportDataList( files, this._fileDropInputConfig );
		if ( files.length ) {
			this.fileDropInput.nativeElement.value = null;
		}
	}
}
